import config from 'config'
import React, { Fragment, useState } from 'react'
import { connect } from 'react-redux'
import { withTranslation } from "react-i18next"
import history from 'srcReact/helpers/history'
import { commonActions } from "srcReact/components"

const TutorialBeginner = (props) => {
    const { t } = props

    const [activeIndex, setActiveIndex] = useState(1)

    const handleNext = () => {
        activeIndex < 3 ? setActiveIndex(activeIndex+1) : setActiveIndex(activeIndex)
    }

    const handleSkipTutorial = () => {
      history.push('/')
    }

    return (
        <Fragment>
            {activeIndex === 1 && <img className="popin-content--confetti" src={`${config.assetUrl}/images/Confetti-Onboarding.png`} alt='Congrats' />}
            <h2 className='popin-content--title'>{t(`popinTutorial.step${activeIndex}.title`)}</h2>
            <p className='popin-content--text'>{t(`popinTutorial.step${activeIndex}.text`)}</p>
            <div className="popin-content--image popin-content--image--gif">
                <img src={`${config.assetUrl}/images/tutorialBegin${activeIndex}.gif`} alt={t(`popinTutorial.step${activeIndex}.title`)} />
            </div>
            <div className="popin-content--pagination">
                <button type="button" onClick={() => setActiveIndex(1)} className={`popin-content--pagination-bullet ${activeIndex === 1 ? 'popin-content--pagination-bullet--active' : ''}`} />
                <button type="button" onClick={() => setActiveIndex(2)} className={`popin-content--pagination-bullet ${activeIndex === 2 ? 'popin-content--pagination-bullet--active' : ''}`} />
                <button type="button" onClick={() => setActiveIndex(3)} className={`popin-content--pagination-bullet ${activeIndex === 3 ? 'popin-content--pagination-bullet--active' : ''}`} />
            </div>
            <div className="popin-content__buttons">
                {activeIndex < 3 ?
                    (<Fragment>
                        <button type='button' className='button is-secondary is-small' onClick={() => handleSkipTutorial()}>{t('popinTutorial.skip')}</button>
                        <button type='button' className='button is-primary is-small' onClick={() => handleNext()}>{t('popinTutorial.next')}</button>
                      </Fragment>
                    )
                    :
                    (<a href={`${config.webUrl}/`} className='button is-primary is-small'>{t('popinTutorial.go')}</a>)
                }
            </div>
        </Fragment>
    )
}

const actionCreators = {
  closePopin: commonActions.closePopin
}

const ExtendedComponent = withTranslation('common')(TutorialBeginner)
const connectedTutorialBeginner = connect(null, actionCreators)(ExtendedComponent)

export { connectedTutorialBeginner as TutorialBeginner }
